import React from "react";
import webuild from "../../assets/webuild.png";

export const Webuild = () => {
    return (
        <section className="w-full min-h-[40vh] flex items-center bg-white py-10">
            <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

                {/* LEFT IMAGE */}
                <div className="flex justify-center md:justify-end">
                    <img
                        src={webuild}
                        alt="industrial"
                        className="w-full max-w-sm sm:max-w-md h-80 object-cover rounded-2xl shadow-lg hover:scale-105 transition duration-300"
                    />
                </div>

                {/* RIGHT CONTENT */}
                <div className="text-center md:text-left">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                        Industrial strength <br />
                        built to last
                    </h1>

                    <p className="mt-4 text-gray-600 text-sm sm:text-base max-w-md mx-auto md:mx-0">
                        Vetri Pipeline Systems delivers precision engineering and reliable
                        industrial solutions. We build the infrastructure that powers
                        industry.
                    </p>
                </div>

            </div>
        </section>
    );
};